import axios from 'axios';
import { CurrencyService } from 'core/api/services/currency';
import React, { useContext, useEffect, useState } from 'react';

const CurrencyContext = React.createContext(null);

export const CurrencyProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [currencies, setCurrencies] = useState([]);
    const [total, setTotal] = useState(0);
    const [currency, setCurrency] = useState('USD');
    const [exchange, setExchange] = useState(0);

    useEffect(() => {
        const currency = window.localStorage.getItem('currency');
        if (currency) {
            setCurrency(currency);
        }
        else
        {
            window.localStorage.setItem('currency', 'USD');
            setCurrency('USD');
        }
    }, []);

    const getCurrencies = async (options) => {
        try {
            setLoading(true);
            const result = await CurrencyService.getList(options);

            if (!result) {
                throw new Error();
            }
            setCurrencies(result.currencies);
            setTotal(result.total);
            return true;
        } catch (err) {
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const updateCurrency = async (currencyId, values) => {
        try {
            setLoading(true);
            const result = await CurrencyService.updateCurrency(currencyId, values);

            if (!result) {
                throw new Error('Error update');
            }

            return true;
        } catch (error) {
            console.error(error);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const getCurrencyExchange = async (fromCurrency, toCurrency) => {
        console.log('from ====', fromCurrency, 'to ====', toCurrency);
        const options = {
            method: 'GET',
            url: 'https://currency-exchange.p.rapidapi.com/exchange',
            params: {
                to: toCurrency.toUpperCase() || 'COP',
                from: fromCurrency.toUpperCase() || 'USD',
                q: '1.0',
            },
            headers: {
                'x-rapidapi-key': '6dd4a3edc8msh9f07d0593500b13p1af642jsnadd7939a04c9',
                'x-rapidapi-host': 'currency-exchange.p.rapidapi.com',
            },
        };
        const response = await axios.request(options);
        // TODO: es necesario el setter?
        setExchange(response.data);
        return response.data;
    };

    return (
        <CurrencyContext.Provider
            value={{
                loading,
                total,
                currencies,
                getCurrencies,
                updateCurrency,
                exchange,
                currency,
                getCurrencyExchange,
                setCurrency,
            }}>
            {children}
        </CurrencyContext.Provider>
    );
};

CurrencyProvider.displayName = 'CurrencyProvider';

export const useCurrencies = () => useContext(CurrencyContext);
